import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import SiteHost from "@/pages/SiteHost";
import Grants from "@/pages/Grants";
import Commercial from "@/pages/Commercial";
import Fleet from "@/pages/Fleet";
import Projects from "@/pages/Projects";
import Technology from "@/pages/Technology";
import Sustainability from "@/pages/Sustainability";
import Contact from "@/pages/Contact";
import Investors from "@/pages/Investors";
import Careers from "@/pages/Careers";
import Blog from "@/pages/Blog";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

export default function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/site-host" element={<SiteHost />} />
                    <Route path="/grants" element={<Grants />} />
                    <Route path="/commercial" element={<Commercial />} />
                    <Route path="/fleet" element={<Fleet />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/technology" element={<Technology />} />
                    <Route path="/sustainability" element={<Sustainability />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/investors" element={<Investors />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}
